<script setup lang="ts">
    import type { BundlesData, BundlesWidgetData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    /**
     * Bundle Widget Container
     * loads a list of bundles
     */
    const props = defineProps<IWidgetProps<BundlesWidgetData>>();
    const { data } = useWidget(props);
    const { locale } = useLocales();
    const { queryParams } = usePreview();

    const bundleIds = computed(() => {
        const b = [];
        if (data && data.bundles) {
            const s = data.bundles.split(',');
            for (const bu of s) {
                b.push(bu.trim());
            }
        }
        return b;
    });
    const { data: bundles, error } = useAsyncData<BundlesData[]>(data.id, () => {
        return new Promise((resolve, reject) => {
            const { data: cachedData } = useNuxtData(data.id);
            const cache = cachedData ? unref(cachedData) : undefined;
            if (cache) {
                // console.log('got bundle cache', data.id);
                resolve(cache);
            } else if (bundleIds.value.length > 0) {
                // console.log('fetching bundle ids', bundleIds.value, preview.value, locale);
                $fetch('/api/bundles', {
                    query: {
                        locale: locale.value,
                        ids: bundleIds.value,
                        ...queryParams.value,
                    },
                })
                    .then((result) => {
                        // console.log('got bundle results', result);
                        // @ts-ignore Bundles are deprecated
                        resolve(result?.data?.bundles || []);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            } else {
                resolve([]);
            }
        });
    });
</script>
<template>
    <org-bundles
        v-if="bundles && bundles.length > 0"
        :background="data.style?.background_color"
        :intro="data.intro"
        :bundles="bundles"
        class="cms-bundle-widget-container" />
</template>
